export enum ProgressColumnTerminology {
  block = 'Block',
  clearedToday = 'Cleared Today',
  clearedTotal = 'Cleared Total',
  percentComplete = 'Percent Complete',
  targetTotal = 'Target Total',
  totalLeft = 'Total Left',
}
